export default __webpack_public_path__ + "d6858dc6980a0479d4816d31417fffc2.mp3";